/**
 * схема для настроек таблицы клиентов
 * @property {array} settingsItems - элементы настроект
 */
let schemeSettingsUserClients = {
    columnSettings: {
        position: {
            type: 'input'
        },
        name: {
            type: 'text'
        },
        id: {
            type: 'dropDown',
            prompt: 'Без менеджера!',
            selected: []
        }
    },
    labels: {
        position: 'Сортировка',
        name: 'Название клиента',
        id: 'Менеджеры'
    }
}

export default schemeSettingsUserClients;